"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("../../atoms");
const providers_1 = require("../../providers");
function LabelsItems({ labelsState, onClose }) {
    const { selectedLabelID, selectedLabelPartID, labels } = labelsState;
    const toolsService = (0, providers_1.useToolsService)();
    const labelManager = toolsService === null || toolsService === void 0 ? void 0 : toolsService.getLabelToolManager();
    const onSelectLabelID = (identifier) => {
        if (identifier === selectedLabelID) {
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectLabel();
            return;
        }
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectLabel(identifier);
    };
    const onSelectLabelPartID = (partId) => {
        if (partId === selectedLabelPartID) {
            labelManager === null || labelManager === void 0 ? void 0 : labelManager.deselectPart();
            return;
        }
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectPart(selectedLabelID, partId);
    };
    const onClickInfo = (identifier) => {
        labelManager === null || labelManager === void 0 ? void 0 : labelManager.selectLabel(identifier, true);
        onClose();
    };
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'LabelsItems_Container', children: (0, jsx_runtime_1.jsx)(LabelsItemsList, { "data-e2e": 'LabelsItems_LabelsItemsList', children: labels === null || labels === void 0 ? void 0 : labels.map(({ identifier, type, text, object, parts }) => {
                if (type === bridge_schema_1.LabelType.Default && object) {
                    const { name, latinName } = object;
                    return ((0, jsx_runtime_1.jsx)(atoms_1.LabelItemDefault, { identifier: identifier, title: name, subtitle: latinName, selectedLabelID: selectedLabelID, onSelectLabelID: onSelectLabelID, onClickInfo: onClickInfo, "data-e2e": 'LabelsItems_LabelItemDefault' }, identifier));
                }
                if (type === bridge_schema_1.LabelType.Custom && text !== undefined) {
                    return ((0, jsx_runtime_1.jsx)(atoms_1.LabelItemCustom, { identifier: identifier, text: text, selectedLabelID: selectedLabelID, onSelectLabelID: onSelectLabelID, "data-e2e": 'LabelsItems_LabelItemCustom' }, identifier));
                }
                if (type === bridge_schema_1.LabelType.Group) {
                    const { name, latinName } = object || {
                        name: text || '',
                        latinName: '',
                    };
                    return ((0, jsx_runtime_1.jsx)(atoms_1.LabelItemGroup, { identifier: identifier, title: name, subtitle: latinName, parts: parts || [], selectedLabelID: selectedLabelID, onSelectLabelID: onSelectLabelID, selectedPartID: selectedLabelPartID, onSelectLabelPartID: onSelectLabelPartID, "data-e2e": 'LabelsItems_LabelItemGroup' }, identifier));
                }
            }) }) }));
}
exports.LabelsItems = LabelsItems;
exports.default = LabelsItems;
const Container = styled_components_1.default.div `
  padding-right: 4px;
  height: 100%;
  width: 100%;
  position: relative;
`;
const LabelsItemsList = styled_components_1.default.div `
  padding: 4px 8px 4px 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.grasshopper.descriptionPanel.scroll.idle};
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb:hover {
    opacity: 0.8;
  }
`;
